<template>
  <div class="bottom">
    <img
      class="title-image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/83c599862e1ff1eab1a4c4c828c9440f.webp"
      alt=""
    />
    <div
      class="b-item"
      v-if="data.integral_goods && data.integral_goods.length"
    >
      <div class="b-title">
        <img
          class="b-title-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/085cc864b146f4a4f5409e949d3634d8.webp"
          alt=""
        />
      </div>
      <div class="exchange-list">
        <div
          class="exchange-item"
          v-for="(item, index) in data.integral_goods"
          :key="index"
          @click="bindToIntegralGoods(item)"
        >
          <img class="item-image" :src="item.goods_detail_img" alt="" />
          <div class="item-btn"></div>
          <div class="exchange">{{ item.redeemed | filterNum }}人已兑换</div>
        </div>
      </div>
    </div>
    <div
      class="b-item"
      v-if="data.more_good_goods && data.more_good_goods.length"
    >
      <div class="b-title">
        <img
          class="b-title-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9de7d4babb12eb9f09c0ba6c3985c04a.webp"
          alt=""
        />
        <div
          class="more"
          @click="bindMore"
          v-clickBuried
          data-click-buried="CLICK_XRQD_MORE"
          >查看更多<span class="iconfont icon-you"></span
        ></div>
      </div>
      <div class="more-container">
        <div class="more-list">
          <div
            class="more-item"
            v-for="(item, index) in data.more_good_goods"
            :key="index"
          >
            <img
              class="item-image"
              :src="item.img"
              alt=""
              @click="bindToMoreGoods(item)"
            />
          </div>
        </div>
      </div>
    </div>
    <img
      class="logo"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7bb65ce254f5a4274c050b49522aa093.webp"
      alt=""
    />
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  filters: {
    filterNum(num) {
      if (num < 9999) {
        return num
      } else {
        return (num / 10000).toFixed(2) + '万'
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    bindToIntegralGoods(item) {
      this.$betterwe.jumpRoute(item.jump_url)
    },
    bindToMoreGoods(item) {
      this.$betterwe.jumpRoute(item.router)
    },
    bindMore() {
      // this.$betterwe.jumpRoute("/wmOtherPage?fromType=11&url=https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/integral/index");
      this.$betterwe.jumpRoute(
        '/wmOtherPage?fromType=11&url=https://t.weimob.com/DT_MYRf'
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom {
  padding: 26px 14px;
  background: #ffddbc;

  .title-image {
    width: 268px;
    height: 27px;
    object-fit: contain;
    margin: 0 auto 22px;
  }

  .b-item {
    .b-title {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .b-title-image {
        height: 25px;
      }

      .more {
        color: rgba(0, 0, 0, 0.5);

        .iconfont {
          margin-left: 3px;
        }
      }
    }

    .exchange-list {
      margin-bottom: 25px;

      .exchange-item {
        height: 115px;
        margin-bottom: 8px;
        position: relative;

        .item-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .item-btn {
          position: absolute;
          width: 66px;
          height: 28px;
          right: 11px;
          bottom: 14px;
        }

        .exchange {
          position: absolute;
          left: 116px;
          bottom: 12px;
          font-size: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #ff6464;
          line-height: 16px;
        }
      }

      .exchange-item:last-child {
        margin-bottom: 0;
      }
    }

    .more-container {
      overflow-y: scroll;
      margin-bottom: 20px;

      .more-list {
        display: inline-flex;

        .more-item {
          width: 112px;
          height: 185px;
          margin-right: 6px;

          .item-image {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }

  .logo {
    margin: 0 auto;
    width: 74px;
    height: 13px;
  }
}
</style>
